<!--
Button to submit forms where the html is in a Ruby .erb file but take advantage of JS pre-submit
-->
<template>
  <input ref        = "form_submit"
         role       = "button"
         tabindex   = "0"
         aria-label = "Submit Form"
         type       = "submit"
         name       = "commit"
         :class     = "btnClasses"
         @click     = "onClick" />
</template>

<script>
  import {blank,
          toBoolean,
          toggleInvalidById,
          clearAllInlineErrors } from '../lib/utils.js'
  import every                   from 'lodash/every'

  export default {
    props: {
      // Classlist of Submit btn
      btnClasses:     { default: 'btn background-color-aqua-blue py-3 fs-5 text-light mt-2 w-100 fw-bolder contact-form-submit-button'},
      // Text inside button
      btnText:        { default: 'Submit' },
      // ID of form in Ruby .erb
      formId:         { default: 'contact_form' },
      // Whether or not to show a loading message onSubmit
      loadingMessage: { default: false }
    },

    computed: {
      // Internal: return the contact form element.
      form() {
        return document.getElementById(this.formId)
      }
    },

    methods: {
      // Internal: returns true if all reqiured inputs and textarea's in the form are valid.
      hasValidFields() {
        const fields = this.form.querySelectorAll('input, textarea')

        return every(fields, (field) => {
          const isBlankRequired = field.hasAttribute('required') && blank(field.value.trim())
          return !isBlankRequired && field.checkValidity()
        })
      },

      // For accessibility purposes, identifies and makes adjustments in DOM to any failing fields on the Ruby form's HTML
      accessibilityPass() {
        clearAllInlineErrors()

        const requiredFields = this.form.querySelectorAll("[required]");

        requiredFields.forEach(field => {
          if (blank(field.value.trim())) {
            toggleInvalidById(field.id, true)
          } else {
            toggleInvalidById(field.id)
          }
        })
      },

      // Button click event handler. If the form fields are valid, disable the button and set the
      // button's message.
      onClick(event) {
        event.preventDefault()

        this.accessibilityPass()

        if (this.hasValidFields()) {
          if (toBoolean(this.loadingMessage)) {
            this.$refs.form_submit.value = 'Sending message...'
          }

          this.$refs.form_submit.disabled = true
          this.form.submit()
        }
      },
    },


    mounted() {
      // This can't be done on load in the template because in some scenarios we show loading text on click
      this.$refs.form_submit.value = this.btnText
    }
  }
</script>

<style lang="scss" scoped>
  .contact-form-submit-button:disabled {
    background-color: black;
  }

  .account-settings-submit-button {
    border-style: none;
  }
</style>
